<div class="container-fluid main-card">
    <div class="row">
        <div class="col-lg-6 offset-lg-3">
            <div class="card shadow mt-4">
                <div *ngIf="authenticationService.isLogin"
                     [stepContent]="searchCityListContent"
                     [joyrideStep]="'searchCityListStep'">
                    <div class="card-header">
                        <div class="card-title">
                            <p class="btn btn-outline float-right mobile-icon" (click)="openTuto()">
                                <img src="assets/icons/yt.png"  class="n-size"alt=""/><span>Tutoriel : Mes secteurs</span>
                            </p>
                            <h2>Mes secteurs</h2>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <mat-form-field>
                                    <mat-label>Séléctionnez un secteur enregistrée</mat-label>
                                    <mat-select disableOptionCentering [(ngModel)]="userSearch" (ngModelChange)="loadSearch()"
                                                [disabled]="userSearchs.length == 0 || !authenticationService.isAllowed('essentiel')"
                                                class="select-search" placeholder="Mes recherches">
                                        <mat-option *ngFor="let s of userSearchs"
                                                    [value]="s">{{ s.title }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-header mt-1">
                    <div class="card-title text-center">
                        <h3>ou</h3>
                    </div>
                </div>
                <div class="card-body col-md-12">
                    <div class="col-md-8 offset-md-2">
                        <a class="btn btn-lg btn-info d-block"
                           (click)="search()">
                            Commencer une nouvelle recherche
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Onboarding -->
<ng-template #searchCityListContent>
    <div class="user_onboarding_content">
        <h2>Secteurs de recherche</h2>
        <p>
            Félicitations !<br/>
            <br/>
            Vous pouvez maintenant retrouver tous vos secteurs enregistrés dans ce menu déroulant.
        </p>
    </div>
</ng-template>
